import { useDispatch } from 'react-redux';

import type { StoreDispatch } from './dispatch.type';

/** Use Store Dispatch. */
export const useStoreDispatch = useDispatch.withTypes<StoreDispatch>();
